import { render, staticRenderFns } from "./SmtpConfigForm.vue?vue&type=template&id=74207202&scoped=true&"
import script from "./SmtpConfigForm.vue?vue&type=script&lang=js&"
export * from "./SmtpConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74207202",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
